import React from "react";
import Header from "../../components/Header";
import Footer from "../../components/Footer";

import ScrollToTop from "../../components/ScrollTop";
import DownloadApp from "../home/DownloadApp";

import Breadcrumb from "../../components/Breadcrumb";
import LoginMain from "./LoginMain";
import { useLocation } from "react-router";

const Login = () => {
   const location = useLocation();
  const {courseID,courseName } = location.state || {};
  return (
    <>
      <Header parentMenu="login" menuCategoryEnable="enable" />

      <div className="react-wrapper">
        <div className="react-wrapper-inner">
          <Breadcrumb pageTitle="Login" />

          <LoginMain />

          {/* download-app-start */}
          <DownloadApp />
          {/* download-app-end */}

          {/* scrolltop-start */}
          <ScrollToTop />
          {/* scrolltop-end */}
        </div>
      </div>

      <Footer />
    </>
  );
};

export default Login;
